export function extractEmailFromSubmission(params, maxDepth = 5) {
  const EMAIL_KEYS = [
    'corporate-email',
    'corp-email',
    'organization-email',
    'org-email',
    'email',
    'mail'
  ];

  const normalizedEmailKeys = EMAIL_KEYS.map(key => key.toLowerCase().replace(/[-_]/g, ''));
  const foundEmails = new Map();

  function collectEmailKeys(obj, depth = 0) {
    if (!obj || typeof obj !== 'object' || depth >= maxDepth) return;

    for (const [key, value] of Object.entries(obj)) {
      if (typeof value === 'string') {
        const normalizedKey = key.toLowerCase().replace(/[-_]/g, '');
        
        for (let i = 0; i < normalizedEmailKeys.length; i++) {
          if (normalizedKey.includes(normalizedEmailKeys[i])) {
            foundEmails.set(i, value);
            break;
          }
        }
      } else if (typeof value === 'object' && value !== null) {
        collectEmailKeys(value, depth + 1);
      }
    }
  }

  collectEmailKeys(params);
  return foundEmails.size > 0 ? foundEmails.get(Math.min(...foundEmails.keys())) : null;
}

export function processFormSubmitCallbacks(responseData) {
  if (window.nv && Array.isArray(window.nv.formSubmitCallbacks)) {
    window.nv.formSubmitCallbacks.forEach((callback) => {
      if (typeof callback === 'function') {
        callback(responseData);
      }
    });
  }
}
